import { render, staticRenderFns } from "./TopicArea.vue?vue&type=template&id=8d311e96&"
import script from "./TopicArea.vue?vue&type=script&lang=ts&"
export * from "./TopicArea.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports